import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import ObtainPersonalAPIKey from "./obtain-personal-api-key.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ObtainPersonalAPIKey mdxType="ObtainPersonalAPIKey" />
    <h4 {...{
      "id": "how-to-authenticate-using-the-personal-api-key"
    }}>{`How to authenticate using the personal API key`}</h4>
    <p>{`There are two options:`}</p>
    <ol>
      <li parentName="ol">{`Use the `}<inlineCode parentName="li">{`Authorization`}</inlineCode>{` header and `}<inlineCode parentName="li">{`Bearer`}</inlineCode>{` authentication, like so:`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-js"
          }}>{`const headers = {
    Authorization: \`Bearer \${POSTHOG_PERSONAL_API_KEY}\`
}
`}</code></pre>
      </li>
      <li parentName="ol">{`Put the key in request body, like so:`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-js"
          }}>{`const body = {
    personal_api_key: POSTHOG_PERSONAL_API_KEY
}
`}</code></pre>
      </li>
    </ol>
    <p>{`Any one of these methods works, but only the value encountered first (in the order above) will be used for authentication.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      